
import React from 'react';
import { Language } from '../../types';
import { TRANSLATIONS } from '../../constants';

interface ServicesHeaderProps {
  language: Language;
  categories: { id: string; label: string; icon: string }[];
  activeCategory: string;
  searchQuery: string;
  isSidebarOpen: boolean;
  onToggleSidebar: () => void;
  onSetSearchQuery: (q: string) => void;
  onSetActiveCategory: (id: string) => void;
  isRtl: boolean;
}

const ServicesHeader: React.FC<ServicesHeaderProps> = ({ 
  language, categories, activeCategory, searchQuery, isSidebarOpen, 
  onToggleSidebar, onSetSearchQuery, onSetActiveCategory, isRtl 
}) => {
  const t = TRANSLATIONS[language];

  return (
    <div className="p-4 lg:p-8 border-b border-slate-100 dark:border-white/5 bg-white/50 dark:bg-[#0f0f13]/50 backdrop-blur-sm shrink-0">
       <div className="flex gap-4">
         <button onClick={onToggleSidebar} className="hidden lg:flex w-11 h-11 items-center justify-center bg-white dark:bg-white/5 border border-slate-200 dark:border-white/10 rounded-2xl text-slate-500 hover:text-emerald-500 transition-colors">
            <i className={`fas ${isSidebarOpen ? 'fa-indent' : 'fa-outdent'} ${isRtl ? 'scale-x-[-1]' : ''}`}></i>
         </button>
         <div className="relative flex-1 max-w-2xl">
           <i className={`fas fa-search absolute ${isRtl ? 'right-4' : 'left-4'} top-1/2 -translate-y-1/2 text-slate-400`}></i>
           <input 
             type="text" 
             value={searchQuery}
             onChange={(e) => onSetSearchQuery(e.target.value)}
             placeholder={t.searchServices}
             className={`w-full bg-white dark:bg-white/5 border border-slate-200 dark:border-white/10 rounded-2xl py-3.5 ${isRtl ? 'pr-12 pl-4' : 'pl-12 pr-4'} text-sm font-bold text-slate-800 dark:text-white outline-none focus:ring-2 focus:ring-emerald-500/20 focus:border-emerald-500 transition-all shadow-sm`}
           />
         </div>
       </div>
       {/* Mobile Categories */}
       <div className="lg:hidden mt-4 -mx-4 px-4 flex gap-2 overflow-x-auto pb-2 scrollbar-hide">
          {categories.map(cat => (
            <button
              key={cat.id}
              onClick={() => onSetActiveCategory(cat.id)}
              className={`
                flex-shrink-0 px-4 py-2.5 rounded-xl text-[11px] font-black whitespace-nowrap border transition-all
                ${activeCategory === cat.id 
                  ? 'bg-emerald-500 text-white border-emerald-500 shadow-md shadow-emerald-500/20' 
                  : 'bg-white dark:bg-white/5 border-slate-200 dark:border-white/5 text-slate-500 dark:text-slate-400'}
              `}
            >
              {cat.label}
            </button>
          ))}
       </div>
    </div>
  );
};
export default ServicesHeader;
